// extracted by mini-css-extract-plugin
export default {"paginationcontainer":"style_paginationcontainer__cb8Je","pagination":"style_pagination__nNP3N","pageitem":"style_pageitem__BKgXh","active":"style_active__co+n1"};